<template>
  <p class="d-inline iconsProductSize">
    <span v-for="(icon, index) in dynamicIcons" :key="index">
      <img
        :src="icon.src"
        :class="icon.class"
        :alt="icon.alt || 'Icono de producto'"
        :title="icon.title"
      />
    </span>
  </p>
</template>

<script setup>
import { computed, toRefs } from 'vue'
import { useSiteConfigStore } from '@/stores/config/site'

// Íconos estáticos
import highVolatility from '@/assets/images/shared/icons/highVolatility.svg'
import discount from '@/assets/images/shared/icons/discount.svg'
import discontinued from '@/assets/images/shared/icons/discontinued.svg'
import newIcon from '@/assets/images/shared/icons/new.svg'
import freeTax from '@/assets/images/shared/icons/freeTax.svg'

const availableIcons = {
  highVolatility,
  discount,
  discontinued,
  new: newIcon,
  freeTax
}

const titles = {
  highVolatility: 'Alta volatilidad',
  discount: 'Descuento',
  discontinued: 'Descontinuado',
  new: 'Nuevo',
  freeTax: 'Libre de impuestos'
}

const props = defineProps({
  product: {
    type: Object,
    required: true
  }
})

const { product } = toRefs(props)
const siteConfigStore = useSiteConfigStore()
const config = siteConfigStore.getProductConfigIcon

const dynamicIcons = computed(() => {
  const icons = []
  const usedPositions = new Set()

  const iconConditions = {
    highVolatility: product.value?.categories?.includes(5),
    discount: product.value.discount > 0 && !product.value.sold_out,
    discontinued: product.value?.discontinued,
    new: product.value?.new,
    freeTax: product.value?.free_tax
  }

  Object.entries(config).forEach(([key, iconConfig]) => {
    if (!iconConfig?.state || !availableIcons[key]) return
    if (!iconConditions[key]) return

    let position = iconConfig.position
    while (usedPositions.has(position)) position++

    icons.push({
      class: `img-fluid iconsProductSize`,
      src: availableIcons[key],
      alt: `${key} icon`,
      title: titles[key],
      position
    })
    usedPositions.add(position)
  })

  return icons.sort((a, b) => a.position - b.position)
})
</script>

<style lang="scss">
.iconsProductSize {
  img {
    width: 2rem;
    opacity: 0.8;
  }
  span {
    margin-right: 0.03rem;
  }
}
</style>
